import React, { Fragment } from 'react';
import Radium from 'radium';
import { func } from 'prop-types';
import Phone from '@material-ui/icons/Phone';
import Email from '@material-ui/icons/Email';
import { UTLabel, UTButton } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';

import ContactItem from './components/ContactItem';
import stylesJS from './styles';
import styles from './styles.module.scss';

const pickColor = color => stylesJS[color];

const EdenContentLayout = ({ onAddComplaint }) => (
  <Fragment>
    <UTLabel bold large>
      {message('Complaints:complaints')}
    </UTLabel>
    {appConfig.complaints.content.map((content, index) => (
      <div style={stylesJS.container} key={content.key}>
        <div style={[stylesJS.innerContainer, index > 0 && stylesJS.minPadding]}>
          {content.sideImage && <img style={stylesJS.sideImage} alt={content.key} src={content.sideImage} />}
          <div style={stylesJS.container}>
            <UTLabel bold small style={{ ...stylesJS.title, ...pickColor(content.color) }}>
              {content.title}
            </UTLabel>
            <div>
              {content.items.map(item => (
                <div key={item.id} style={stylesJS.itemContentContainer}>
                  <UTLabel light small>
                    {`${item.content}`}
                  </UTLabel>
                </div>
              ))}
            </div>
          </div>
        </div>
        {content.sideImage && appConfig.complaints.content.length - 1 > index && <hr style={stylesJS.hr} />}
      </div>
    ))}
    <UTLabel large bold className={styles.contactLabel}>
      {message('Complaints:contactTitle')}
    </UTLabel>
    <div style={stylesJS.contactContainer}>
      <UTButton className={styles.addComplaint} onPress={onAddComplaint}>
        {message('Complaints:crimeComplaintButton')}
      </UTButton>
      <ContactItem
        Icon={Phone}
        href={`tel: ${appConfig.complaints.contactPhone}`}
        contact={appConfig.complaints.contactPhone}
        additionalInfo={message('Complaints:atentionHours')}
      />
      <ContactItem
        Icon={Email}
        href={`mailto: ${appConfig.complaints.contactMail}`}
        contact={appConfig.complaints.contactMail}
      />
    </div>
  </Fragment>
);

EdenContentLayout.propTypes = {
  onAddComplaint: func.isRequired
};

export default Radium(EdenContentLayout);
